<template>

  <!-- <div>
    <div v-if="isGranted([permissions.SYSTEM_NETWORK_VIEW, permissions.SYSTEM_NETWORK_VIEW_OWN], system)"
         class="card network"
         qid="network-section"
         id="update_network"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="network-table-title" v-if="!showOnTask">
                {{ $t('systems.network.title') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_network')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_network')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_network')"
                      class="cursor-pointer"
                      @click="openHelpCenter(getGuide('update_network'))"
                >
                  <font-awesome-icon icon="info-circle"/>
                  {{ $t('system.help_center_label') }}
                </span>
              </span>
            </div>
            <div class="validation-info" qid="view-n-validation" v-if="!showOnTask">
              <span v-if="validation && validation.validation === 1" qid="network-validation-approved">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
                {{ $t('system.approved') }}
              </span>
              <span v-if="validation && validation.validation === 0" qid="network-validation-rejected">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
                {{ $t('system.rejected') }}
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.by') }}
                <span v-if="validation.created_by" qid="view-n-validation-by">
                  {{ validation.created_by.name }}
                </span>
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.on') }}
                <span v-if="validation.created_at" qid="view-n-validation-date">
                  {{ validation.created_at | formatDate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <ValidationForm
                :object="system"
                type="network"
                scope="validate_network"
                :checklist="validationOptions"
                :disabledItems="disabledValidationOptions"
                @validationModalClose="handleValidationModalClose"
                v-if="!showOnTask && isGranted([permissions.SYSTEM_NETWORK_VALIDATE, permissions.SYSTEM_NETWORK_VALIDATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            ></ValidationForm>
            <span class="btn btn-success"
                    @click="showCreateNModal()"
                    qid="network-create-button"
                    v-if="isGranted([permissions.SYSTEM_NETWORK_CREATE, permissions.SYSTEM_NETWORK_CREATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('systems.network.create_button') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('systems.network.table.name') }}
              </th>
              <th scope="col" class="text-center">
                {{ $t('systems.network.table.exposed_to_open_networks') }}
              </th>
              <th scope="col">
                {{ $t('system.last_updated') }}
              </th>
              <th width="200"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="object in nTableItems">
              <td>
                <span v-if="object.network && object.network.name"
                      @click="openViewModal(object)"
                      qid="network-link"
                      class="btn btn-link btn-sm text-left cursor-pointer"
                >
                  {{ object.network.name }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object && object.exposed_to_open_networks">
                  {{ $t('systems.network.' + $options.filters.slugify(object.exposed_to_open_networks)) }}
                </span>
              </td>
              <td>
                <span>
                  <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td align="right">
                <span v-if="object.network && object.network.name"
                      @click="openViewModal(object)"
                      qid="network-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>
                <span class="btn btn-edit"
                      qid="edit-n-modal"
                      @click="showEditNModal(object)"
                      v-if="isGranted([permissions.SYSTEM_NETWORK_EDIT, permissions.SYSTEM_NETWORK_EDIT_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span class="btn btn-delete"
                      qid="delete-n-modal"
                      @click="showNConfirmDeleteModal(object)"
                      v-if="isGranted([permissions.SYSTEM_NETWORK_DELETE, permissions.SYSTEM_NETWORK_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!nLoading && !nTableItems.length" qid="no-results-row-n" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <div class="text-center mb-4" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="nValidationShow = !nValidationShow"
                qid="network-validation-expand"
          >
            <span class="mr-2">{{ $t('system.view_validation_log') }}</span>
            <font-awesome-icon icon="chevron-down" v-if="!nValidationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="nValidationShow"/>
          </span>
        </div>
        <hr class="mb-0" v-show="nValidationShow && !showOnTask">
        <ValidationList
            :object="system"
            type="network"
            :reloadList="updateValidationList"
            @validationListUpdated="setValidation"
            v-show="nValidationShow && !showOnTask"
        ></ValidationList>
      </div>
    </div>


    <b-modal ref="delete-n" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-n-title">
          {{ $t('systems.network.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('systems.network.delete.description') }}
        <span v-if="itemToDelete.network">{{ itemToDelete.network.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('systems.network.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideNConfirmDeleteModal"
                  qid="delete-n-cancel-button"
        >
          {{ $t('systems.network.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteN(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-n-submit-button"
                  v-if="isGranted([permissions.SYSTEM_NETWORK_DELETE, permissions.SYSTEM_NETWORK_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
        >
          {{ $t('systems.network.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <b-modal ref="add-network" hide-footer @hide="hideCreateNModal">
      <div class="d-block text-center">
        <h4 qid="add-n-title">
          {{ $t('systems.network.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-n-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="nFormSubmit" qid="create-n-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-n-pg-label">
              {{ $t('systems.network.create.n_label') }}
            </label>
            <multiselect
                v-model="selectedN"
                :options="nItems"
                :placeholder="$t('systems.network.create.n_placeholder')"
                label="name"
                @search-change="loadN"
                @select="resetFields"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="slug"
                qid="create-n-form-n"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedN && selectedN.exposed_to_open_networks">
            <label qid="create-n-exposed-label">
              {{ $t('systems.network.create.exposed_label') }}
            </label>
            <multiselect
                v-model="selectedDropdownOption"
                :options="dropdownOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.network.create.exposed_placeholder')"
                qid="create-n-form-exposed"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedN && selectedN.id">
            <label qid="create-n-description-label">
              {{ $t('systems.network.create.description_label') }}
            </label>
            <b-form-textarea
              qid="n-form-description"
              v-model="nForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.network.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateNModal"
                    qid="create-n-cancel-button"
          >
            {{ $t('systems.network.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-n-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.network.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <b-modal ref="edit-n" hide-footer @hide="hideEditNModal">
      <div class="d-block text-center">
        <h4 qid="add-n-title">
          {{ $t('systems.network.edit.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-n-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formEditNSubmit" qid="edit-n-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-n-label">
              {{ $t('systems.network.create.n_label') }}
            </label>
            <br>
            <span v-if="selectedN">
              {{ selectedN.name }}
            </span>
          </b-form-group>
          <b-form-group v-if="selectedN && selectedN.exposed_to_open_networks">
            <label qid="create-n-exposed-label">
              {{ $t('systems.network.create.exposed_label') }}
            </label>
            <multiselect
                v-model="selectedDropdownOption"
                :options="dropdownOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.network.create.exposed_placeholder')"
                qid="create-n-form-exposed"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedN && selectedN.id">
            <label qid="create-n-description-label">
              {{ $t('systems.network.create.description_label') }}
            </label>
            <b-form-textarea
              qid="n-form-description"
              v-model="nForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.network.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditNModal"
                    qid="create-n-cancel-button"
          >
            {{ $t('processes.legal_basis.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-n-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('processes.legal_basis.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <NetworkViewModal
        :object="selectedN"
        v-if="selectedN"
        :showModal="viewNModal"
        @closeViewModal="closeViewModal"
    ></NetworkViewModal>

  </div> -->

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import NetworkViewModal from '@/views/Systems/NetworkViewModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';

  export default {
    name: 'NetworkTable',
    data: function() {
      return {
        nForm: {
          name: '',
          exposed_to_open_networks: '',
          description: ''
        },
        error: '',
        loadingItems: false,
        selectedN: [],
        editNModal: false,
        selectedNSort: '',
        selectedNDirection: '',
        nValidationShow: false,
        nTableItems: [],
        nLoading: true,
        nItems: [],
        updateValidationList: false,
        itemToDelete: {},
        object: {},
        dropdownOptions: [],
        selectedDropdownOption: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        buttonDisabled: false,
        viewNModal: false,
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      system: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      NetworkViewModal,
      UpdateSingleTaskModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadN();
      },
      system: function (value) {
        if (value && value.id) {
          this.system = value;
          this.loadTasks('update_network');
          this.loadNetwork();
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.system.id && this.$store.state.updatedObject.who_am_i == this.system.who_am_i) {
              this.system = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_network')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadLogManagement();
        this.loadTasks('update_network');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.system.who_am_i,
              model_id: this.system.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'systems.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'System' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'System',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      openHelpCenter(object) {
        let topElement = document.getElementById("app");
        if (topElement.classList.contains("guide-collapsed")) {
          topElement.classList.toggle("guide-collapsed");
        }
        if (!topElement.classList.contains("activity-collapsed")) {
          topElement.classList.toggle("activity-collapsed");
        }

        this.$store.commit('storeHelpCenterState', true);
        this.$store.commit('storeActiveGuideScope', object);
      },
      resetFields() {
        this.selectedDropdownOption = null
      },
      setValidation(object) {
        this.validation = object
      },
      closeViewModal () {
        this.viewNModal = false;
        this.selectedN = []
      },
      openViewModal(object) {
        this.selectedN = object
        this.viewNModal = true
      },
      openEditNModal(object) {
        this.selectedN = object
      },
      showCreateNModal() {
        this.$refs['add-network'].show()
      },
      hideCreateNModal() {
        this.error = ''
        this.selectedN = []
        this.selectedDropdownOption = []
        this.nForm.description = ''
        this.loadContent();
        this.$refs['add-network'].hide()
      },
      showEditNModal(object) {
        let self = this;
        this.selectedN = object.network

        this.selectedDropdownOption = []
        if (object.exposed_to_open_networks) {
          _.find(this.dropdownOptions, function(item) {
            if (item.value == object.exposed_to_open_networks) {
              self.selectedDropdownOption = item;
            }
          });
        }

        this.nForm.description = object.description
        this.object = object
        this.$refs['edit-n'].show()
      },
      hideEditNModal() {
        this.error = ''
        this.selectedN = []
        this.selectedDropdownOption = []
        this.nForm.description = ''
        this.loadContent();
        this.$refs['edit-n'].hide()
      },
      showNConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-n'].show()
      },
      hideNConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent();
        this.$refs['delete-n'].hide()
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      loadContent() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.system = response.data;
          self.setDisabledValidations();
        }, function() {});
      },
      loadNetwork() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug + '/networks', { params:
          {
            client: this.getClient.slug,
          }
        }).then(function(response) {
          self.nTableItems = response.data;
          self.nLoading = false;
        }, function() {});
      },
      confirmDeleteN(object) {
        let self = this;
        piincHttp.delete('systems/' + this.system.slug + '/networks/' + object.id).then(function() {
          self.hideNConfirmDeleteModal();
          self.loadNetwork();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('systems.network.delete.success'))
        }, function() {});
      },
      nFormSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedN && this.selectedN.id) {
          formData.append("network_id", this.selectedN.id);
        }

        formData.append("system", this.system.slug);
        formData.append("description", this.nForm.description);

        if (this.selectedDropdownOption) {
          formData.append("exposed_to_open_networks", this.selectedDropdownOption.value);
        }

        piincHttp.post('/systems/' + this.system.slug + '/networks', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('systems.network.create.success'))
          self.hideCreateNModal();
          self.buttonDisabled = false;
          self.loadNetwork();
          self.$emit('updated');
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.network_id) {
              self.error += ' ' + error.data.errors.network_id[0]
            }
          }
        })
      },
      formEditNSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedN) {
          this.nForm.network_id = this.selectedN.id;
        }

        this.nForm.exposed_to_open_networks = this.selectedDropdownOption.value

        piincHttp.put('systems/' + this.system.slug + '/networks/' + this.object.id, this.nForm).then(function() {
          self.hideEditNModal();
          self.loadNetwork();
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('systems.network.edit.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.network_id) {
              self.error += ' ' + error.data.errors.network_id[0]
            }
          }
        })
      },
      loadN(query) {
        let self = this;
        piincHttp.get('networks', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.nItems = response.data.items
          if (self.nItems && !self.nItems.length && !query) {
            self.nItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.nItems && self.nItems.length) {

            self.dropdownOptions = []
            _.forEach(self.nItems[0].exposedToOpenNetworksOptions, function(item) {
              let object = {
                name: self.$t('systems.network.' + self.$options.filters.slugify(item)),
                value: item
              }
              self.dropdownOptions.push(object)
            })

          }
          self.setDisabledValidations();
        }, function() {});
      },
      setDisabledValidations() {
        this.disabledValidationOptions = [];
        if (this.system.networksValidation.exposed_to_open_networks == false) {
          this.disabledValidationOptions.push('Exposed to open networks')
        }
      }
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        this.loadN();
      }
      if (this.system && this.system.id) {
        this.loadTasks('update_network');
        this.loadNetwork();
        this.validationOptions = _.cloneDeep(this.system.networkValidationOptions)
      }

      this.loadGuides('update_network');

    }
  }
</script>
